import { render, staticRenderFns } from "./LafiaStudio.vue?vue&type=template&id=c1512f52&scoped=true"
import script from "./LafiaStudio.vue?vue&type=script&lang=js"
export * from "./LafiaStudio.vue?vue&type=script&lang=js"
import style0 from "./LafiaStudio.vue?vue&type=style&index=0&id=c1512f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../컨셉펀딩/worktrees/yesandlegeyo-copy-test-20260921/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1512f52",
  null
  
)

export default component.exports